import React from "react"
import { ImgS } from "ui-seeker/core"

import { IMAGE } from 'app/@common/constants'


const TmpLogo=({ siteName }) => <abbr style={{
    display: 'inline-block', verticalAlign: 'middle', width: '20px', textAlign: 'center', lineHeight: '0'
}}>
    <ImgS
        src={`${IMAGE.ASSETS}/${siteName?.split('.')[0]}-mini.png`} alt={`${siteName} logo`} onError={i => i.target.src = `${IMAGE.ASSETS}/web.png`}
        style={{ display: "inline-block", height: "1em", verticalAlign: "middle", maxWidth: '100%'}}
    />
</abbr>

const TmpSiteName=({ siteName='' }) => <abbr style={{ display: 'inline-block', verticalAlign: 'middle' }}>{` ${siteName}`}</abbr>

export const formatSiteWithLogo=({ siteName } = {}) => {
    return <>
        <TmpLogo siteName={siteName} /> <TmpSiteName siteName={siteName} />
    </>
}